module.exports = __webpack_public_path__ + "static/media/khaldoun.465ac3d8.jpg";